<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">New working period</h3>
  </div>
  <div class="dialog-content__container">
    <form [formGroup]="workingPeriodForm">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="form__item row mb-3 mt-16">
              <label
                class="col-sm-3 d-flex align-items-center"
                appMarkAsterisk
                [formGroup]="workingPeriodForm"
                [controlName]="'createdBy'"
                [touched]="workingPeriodForm.get('createdBy')!.touched"
                >Created By</label
              >
              <div class="col-sm-3">
                <app-dropdown
                  formControlName="createdBy"
                  [isMultiselect]="false"
                  [items]="createdByOptionsList"
                  [border]="'classic'"
                ></app-dropdown>
              </div>
            </div>
            <div class="form__item row mb-3">
              <label
                class="col-sm-3 d-flex align-items-center"
                appMarkAsterisk
                [formGroup]="workingPeriodForm"
                [controlName]="'newStatus'"
                [touched]="workingPeriodForm.get('newStatus')!.touched"
                >New status</label
              >
              <div class="col-sm-3">
                <app-dropdown
                  formControlName="newStatus"
                  [isMultiselect]="false"
                  [items]="statusDropdown"
                  [border]="'classic'"
                ></app-dropdown>
              </div>
              <div
                *ngIf="this.workingPeriod.isNewStatusContractor && !isFormer"
                class="col-sm-3 d-flex align-items-center form-validation"
              >
                <label
                  class="col-sm-7 d-flex align-items-center"
                  appMarkAsterisk
                  [formGroup]="workingPeriodForm"
                  [controlName]="'startDate'"
                  [touched]="workingPeriodForm.get('startDate')!.touched"
                  >Contract start</label
                >

                <app-datepicker
                  [iconLeft]="true"
                  formControlName="startDate"
                ></app-datepicker>
                <app-error-field
                  [displayError]="workingPeriodForm.hasError('invalidDate')"
                  [errorMessage]="'Contract cannot start before End date'"
                >
                </app-error-field>
              </div>
            </div>
            <ng-container
              *ngIf="
                currentStatusId >
                  this.workingPeriod.formControl('newStatus')?.getRawValue()
                    ?.id;
                else increase
              "
            >
              <app-decrease-employment-position-form
                [decreasePeriodDropdowns]="decreaseDropdowns"
              >
              </app-decrease-employment-position-form>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0 mb-3">
      <button
        type="button"
        class="button button__save add-margin"
        (click)="save()"
      >
        Save
      </button>
      <button type="button" class="button button__cancel" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div>

<ng-template #increase>
  <app-increase-employment-position-form
    [increasePeriodDropdowns]="increaseDropdowns"
    [isPMAllowToChoose]="data.isPMAllowToChoose"
  >
  </app-increase-employment-position-form>
</ng-template>
